<template>
    <div class="spaces-mobile-bar">
      <div class="spaces-mobile-bar__box">
        <div class="spaces-mobile-bar__price">
          <template v-if="price">
            {{$store.getters.language.FROM}}<br>
            ${{ price }}/day
          </template>
        </div>
        <ButtonPrimary :title="'Request'" @buttonClick="toggleWidget()"></ButtonPrimary>
      </div>
      <div class="spaces-mobile-bar__widgets">
        <div class="spaces-mobile-bar__widget" :class="{ 'is--toggled': active }">
          <a href="#" @click.prevent="active = false" class="spaces-mobile-bar__widget-close">
            <img src="/assets/icon_close.svg" alt="Close">
          </a>
          <EnquiryWidget @fromPrice="getPrice" :user="user ? user.id : null" :id="id"></EnquiryWidget>
        </div>
      </div>
      <div class="spaces-mobile-bar__bg" @click.prevent="active = false" :class="{ 'is--toggled': active }"></div>
    </div>
</template>

<script>
import EnquiryWidget from "../../components/search/EnquiryWidget"
import ButtonPrimary from "../../components/global/ButtonPrimary"

export default {
  name: 'SpacesMobileBar',
  data: () => ({
    active: false,
    price: null
  }),
  props: {
    id: {
      default: null,
      type: String
    },
    user: {
      default: null,
      type: Object
    },
    receiver: {
      default: null,
      type: Number
    },
    listing: {
      default: null,
      type: Object
    }
  },
  components: {
    EnquiryWidget,
    ButtonPrimary
  },
  methods: {
    getPrice (amount) {
      this.price = amount
    },  
    toggleWidget (widget) {
      this.active = !this.active
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";


.spaces-mobile-bar {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1009;
  width: 100%;
  bottom: 0px;
  background: $divider-dark;
  border-radius: 4px 4px 0 0;
  @include breakpoint(tablet-landscape) {
    display: block;
  }
}

.spaces-mobile-bar__box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 75px;
}

.spaces-mobile-bar__price {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 3px;
  color: $primary-grey;
  @include responsive-text-size('Body--16--Regular');
}

.spaces-mobile-bar__widget {
  position: fixed;
  pointer-events: none;
  visibility: hidden;
  left: 0;
  right: 0;
  z-index: 1009;
  width: 100%;
  bottom: 0px;
  border-radius: 10px 10px 0 0;
  transform: translate(0, 100%);
  @include transform(translate(0, 100%));
  @include ease;

  &.is--toggled {
    pointer-events: auto;
    visibility: visible;
    @include transform(translate(0, 0));
  }
}

.spaces-mobile-bar__widget-close {
  position: absolute;
  top: 24px;
  right: 24px;
}

.spaces-mobile-bar__bg {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  @include ease;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1008;
  background: rgba(#000000, 0.3);
  @include breakpoint(tablet-landscape) {
    &.is--toggled {
      opacity: 1;
      pointer-events: auto;
      visibility: visible;
    }
  }
}

</style>
